// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"0c55d554","46":"06beb114","155":"ae994c00","287":"f209172b","604":"152d5a1f","667":"1dcfb8f0","787":"d05bb4e8","877":"a3c2fefb","972":"25ce310e"}[chunkId] + ".chunk.js";
};